import React, { useEffect, useState } from "react";
import profilephoto from "../assets/images/Ellipse.png";
import { useNavigate, useLocation } from "react-router-dom";
import AdvisorCardSlider from "../components/Advisors/AdvisorCardSlider";
import { Tooltip } from "antd";
import { getStatusDisplayText } from "../utils/statusUtils";
import { useDispatch } from "react-redux";
import { exitTrade, ignoreTrade } from "../store/Slice/DashboardSlice";
import { apiServices } from "../services/Api";
const Card1 = ({ data, onArchive, isArchived = false, daysRemaining }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [traders, setTraders] = useState(0);
  const [showExitModal, setShowExitModal] = useState(false);

  useEffect(() => {
    if (shouldArchiveByDuration(data) && !isArchived && onArchive) {
      onArchive(data.id);
    }
  }, [data, isArchived, onArchive]);

  useEffect(() => {
    const fetchTradersCount = async () => {
      try {
        if (data?.id) {
          const response = await apiServices.get(
            `advisors/calls/${data.id}/tradersCount`
          );
          setTraders(response?.tradersCount ?? 0);
        }
      } catch (error) {
        console.error("Error fetching traders count:", error);
      }
    };
    fetchTradersCount();
  }, [data?.id]);
  const formatNumber = (num) => {
    if (!num && num !== 0) return "-";
    const number = parseFloat(num);
    if (isNaN(number)) return num;

    if (number >= 10000) {
      return number.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    }
    return number.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  const shouldArchiveByDuration = (data) => {
    if (!data.createdAt || !data.holdingDurationInDays) return false;

    const createdDate = new Date(data.createdAt);
    const currentDate = new Date();

    createdDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const durationInDays = parseInt(data.holdingDurationInDays, 10);

    const timeDiff = currentDate.getTime() - createdDate.getTime();

    const daysPassed = Math.floor(timeDiff / (1000 * 3600 * 24));

    return daysPassed >= durationInDays;
  };

  const handleExitClick = () => {
    setShowExitModal(true);
  };

  const handleConfirmExit = () => {
    if (data.status === "YET_TO_TRIGGER") {
      dispatch(ignoreTrade({ id: data.id }));
      if (onArchive) onArchive(data.id);
    } else if (data.status?.includes("LIVE")) {
      dispatch(exitTrade({ id: data.id }));
      if (onArchive) onArchive(data.id);
    }
    setShowExitModal(false);
  };

  const handleCancelExit = () => {
    setShowExitModal(false);
  };

  const showArchiveButton = isArchived;

  return (
    <div className="w-full xs:px-2 sm:px-3 md:px-2 lg:px-2">
      <div className="relative flex flex-col p-3 xs:p-4 sm:p-5 md:p-6 lg:p-7 rounded-[8px] border border-[#E5E5E5] bg-white font-inter w-full shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-md transition-shadow">
        {(data.segmentTag || daysRemaining) && (
          <div className="flex flex-wrap gap-2">
            {data.segmentTag && (
              <div className="px-3 py-1.5 rounded-lg bg-brand-lightBlue text-primary text-xs font-medium whitespace-nowrap">
                {data.segmentTag}
              </div>
            )}
            {daysRemaining && (
              <div className="px-3 py-1.5 rounded-lg bg-orange-100 text-orange-700 text-xs font-medium whitespace-nowrap">
                {daysRemaining} day{daysRemaining !== 1 ? "s" : ""} left
              </div>
            )}
          </div>
        )}

        <div className="mt-3 xs:mt-4 flex flex-col xl:flex-row xl:items-center xl:justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <img
              src={profilephoto}
              alt="profile"
              className="w-10 h-10 xs:w-12 xs:h-12 rounded-full object-cover border border-gray-100"
            />

            <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-wrap sm:flex-nowrap">
              <Tooltip placement="bottomLeft" title={data.tradingSymbol}>
                <h3 className="text-base xs:text-lg sm:text-lg lg:text-lg xl:text-lg font-bold text-[#454545] leading-snug min-w-0 w-[180px] sm:w-[240px] lg:w-[300px] truncate whitespace-nowrap">
                  {data.tradingSymbol}
                </h3>
              </Tooltip>

              <div
                className={`px-2.5 py-1 rounded-md text-white font-bold text-xs tracking-wide text-center w-14 shrink-0 ${
                  data?.transactionType === "SELL"
                    ? "bg-brand-red"
                    : "bg-[#119b42]"
                }`}
              >
                {data.transactionType}
              </div>

              <div className="hidden sm:flex items-center gap-x-3 gap-y-1 text-sm text-[#7F7F7F] min-w-0 flex-wrap">
                <div className="flex items-center gap-2 min-w-0 whitespace-nowrap">
                  <span className="text-xs sm:text-sm lg:text-base xl:text-base">Status</span>
                  <Tooltip
                    title={getStatusDisplayText(
                      data.status,
                      data.percentToTrigger
                    )}
                  >
                    <span className="font-bold text-[#454545] text-xs sm:text-sm lg:text-base xl:text-base">
                      {getStatusDisplayText(data.status, data.percentToTrigger) || "Yet To Trigger"}
                    </span>
                  </Tooltip>
                </div>

                <span className="text-gray-300">•</span>

                <div className="flex items-center gap-2 whitespace-nowrap">
                  <span className="text-xs sm:text-sm lg:text-base xl:text-base">Confidence</span>
                  <span className="font-bold text-[#454545] text-xs sm:text-sm lg:text-base xl:text-base">
                    {data.confidence}%
                  </span>
                </div>

                <span className="text-gray-300">•</span>

                <div className="flex items-center gap-2 whitespace-nowrap">
                  <span className="text-xs sm:text-sm lg:text-base xl:text-base">Traders</span>
                  <span className="font-bold text-[#454545] text-xs sm:text-sm lg:text-base xl:text-base">{traders}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 w-full justify-start sm:w-auto sm:justify-end flex-wrap xl:flex-nowrap xl:shrink-0">
            {onArchive && showArchiveButton && (
              <button
                className={`w-full sm:w-auto flex py-2 px-3 lg:px-4 justify-center items-center rounded-lg text-white text-xs lg:text-sm font-medium cursor-pointer border-none transition-colors ${
                  isArchived
                    ? "bg-green-500 hover:bg-green-600"
                    : "bg-gray-500 hover:bg-gray-600"
                }`}
                onClick={() => onArchive(data.id)}
              >
                {isArchived ? "Unarchive" : "Archive"}
              </button>
            )}

            {(data.status === "YET_TO_TRIGGER" ||
              data.status?.includes("LIVE")) && (
              <button
                className="w-full sm:w-auto flex py-2 px-3 lg:px-4 justify-center items-center rounded-lg bg-brand-red text-white text-xs lg:text-sm font-medium cursor-pointer border-none hover:bg-red-600 transition-colors"
                onClick={handleExitClick}
              >
                {data.status === "YET_TO_TRIGGER" ? "Ignore" : "Exit"}
              </button>
            )}

            <button
              className="w-full sm:w-auto flex py-2 px-4 lg:px-6 justify-center items-center rounded-lg bg-primary text-white text-xs sm:text-sm lg:text-base font-medium cursor-pointer border-none hover:bg-primary/80 transition-colors"
              onClick={() => navigate("/edittrade", { state: { ...data, from: location.pathname } })}
            >
              Edit
            </button>
          </div>

          <div className="sm:hidden flex items-center gap-3 text-xs text-[#7F7F7F] flex-wrap">
            <div className="flex items-center gap-2 min-w-0 whitespace-nowrap">
              <span className="text-xs sm:text-sm lg:text-base xl:text-base">Status</span>
              <Tooltip
                title={getStatusDisplayText(data.status, data.percentToTrigger)}
              >
                <span className="font-bold text-[#454545] text-xs sm:text-sm lg:text-base xl:text-base">
                  {getStatusDisplayText(data.status, data.percentToTrigger) || "Yet To Trigger"}
                </span>
              </Tooltip>
            </div>

            <span className="text-gray-300">•</span>

            <div className="flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm lg:text-base xl:text-base">
              <span>Confidence</span>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] ">
                {data.confidence}%
              </span>
            </div>

            <span className="text-gray-300">•</span>

            <div className="flex items-center gap-2 whitespace-nowrap text-xs sm:text-sm lg:text-base xl:text-base">
              <span>Traders</span>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545]">{traders}</span>
            </div>
          </div>
        </div>

        <div className="mt-4 xs:mt-5 border-t border-gray-100 pt-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-4">
            <div className="flex flex-col items-center justify-center px-2 py-2">
              <Tooltip title={formatNumber(data.price)}>
                <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] truncate text-center">
                  {formatNumber(data.price)}
                </span>
              </Tooltip>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base text-[#7F7F7F] mt-1 text-center">
                Current Price
              </span>
            </div>

            <div className="text-xs sm:text-sm lg:text-base xl:text-base flex flex-col items-center justify-center px-2 py-2">
              <Tooltip
                title={
                  data.entryPriceLower !== null && data.entryPriceUpper !== null
                    ? `${data.entryPriceLower}-${data.entryPriceUpper}`
                    : "-"
                }
              >
                <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] truncate text-center">
                  {data.entryPriceLower !== null &&
                  data.entryPriceUpper !== null
                    ? `${data.entryPriceLower}-${data.entryPriceUpper}`
                    : "-"}
                </span>
              </Tooltip>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base text-[#7F7F7F] mt-1 text-center">
                Entry Price Range
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-2 py-2">
              <Tooltip title={formatNumber(data.targetPrice)}>
                <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] truncate text-center">
                  {formatNumber(data.targetPrice)}
                </span>
              </Tooltip>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base text-[#7F7F7F] mt-1 text-center">
                Target
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-2 py-2">
              <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] truncate text-center">
                {data.duration} Days
              </span>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base text-[#7F7F7F] mt-1 text-center">
                Duration
              </span>
            </div>

            <div className="flex flex-col items-center justify-center px-2 py-2">
              <Tooltip title={`${data.stoploss}%`}>
                <span className="text-xs sm:text-sm lg:text-base xl:text-base font-bold text-[#454545] truncate text-center">
                  {data.stoploss}
                </span>
              </Tooltip>
              <span className="text-xs sm:text-sm lg:text-base xl:text-base text-[#7F7F7F] mt-1 text-center">SL</span>
            </div>

            <div className="flex flex-col items-center justify-center px-2 py-2 col-span-2 sm:col-span-3 lg:col-span-1">
              <div className="w-full flex items-center justify-center">
                <AdvisorCardSlider
                  minValue={data.stoploss}
                  maxValue={data.targetPrice}
                  startValue={data.entryPriceLower}
                  endValue={data.entryPriceUpper}
                  currentPrice={data.price}
                  status={data.status}
                  transactionType={data.transactionType}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showExitModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 xs:p-3 sm:p-4">
          <div className="bg-white rounded-lg w-full max-w-xs xs:max-w-sm sm:max-w-md p-4 xs:p-5 sm:p-6 relative">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl"
              onClick={handleCancelExit}
            >
              ✕
            </button>

            <h2 className="text-base xs:text-lg sm:text-xl lg:text-2xl font-semibold mb-3 xs:mb-4 text-gray-800">
              {data.status === "YET_TO_TRIGGER"
                ? "Ignore this trade?"
                : "EXIT this trade at CMP?"}
            </h2>

            <p className="text-xs xs:text-sm sm:text-base text-gray-600 mb-3 xs:mb-4 whitespace-pre-line">
              {data.status === "YET_TO_TRIGGER"
                ? "Are you sure you want to ignore this trade?"
                : "Users will be notified to EXIT this trade at CMP urgently. Are you sure about this?"}
            </p>

            <div className="flex gap-2 xs:gap-3 justify-end">
              <button
                onClick={handleCancelExit}
                className="px-2 xs:px-3 sm:px-4 py-1.5 xs:py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 font-medium transition-colors text-xs xs:text-sm sm:text-base"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmExit}
                className="px-2 xs:px-3 sm:px-4 py-1.5 xs:py-2 bg-brand-red hover:bg-brand-red/80 text-white rounded-md font-medium transition-colors text-xs xs:text-sm sm:text-base"
              >
                Yes, {data.status === "YET_TO_TRIGGER" ? "Ignore" : "Exit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card1;
